<template>
	<GmapMap
		ref="ref__googlemaps"
		map-type-id="satellite"
		class="container__googlemaps__position"
		:center="{ lat: 0, lng: 0 }"
		:zoom="2"
		:options="{
			mapTypeControl: false,
			scaleControl: false,
			zoomControl: false,
			streetViewControl: false,
			fullscreenControl: false,
		}"
	>
		<template #visible>
			<slot />
			<div
				v-if="getGeoJsonPtio.features"
				class="px-2 py-1 bg-white rounded-full z-1 relative w-fit my-4 float-right"
			>
				<Switcher
					:label="$t('showPlantationInfo')"
					:value="showMarkers"
					@input="setShowMarkers($event)"
				/>
			</div>
		</template>

		<GmapCluster
			:max-zoom="10"
			:zoom-on-click="true"
			:styles="[
				{
					width: 30,
					height: 30,
					className: 'custom-clustericon-1',
				},
				{
					width: 40,
					height: 40,
					className: 'custom-clustericon-2',
				},
				{
					width: 50,
					height: 50,
					className: 'custom-clustericon-3',
				},
			]"
			cluster-class="custom-clustericon"
		>
			<div v-if="isDashboardGeral">
				<gmap-marker
					v-for="(dataIndividual, index) in cardInfoWithInfoGeo"
					:key="index"
					:position="{
						lat: dataIndividual.infoGeo.centroId.coordinates[1],
						lng: dataIndividual.infoGeo.centroId.coordinates[0],
					}"
				/>
			</div>
		</GmapCluster>
		<div v-if="showMarkers">
			<PlantioMarker
				v-for="plantioMarker in plantioMarkers"
				:key="plantioMarker.infoPoligono.centroId.coordinates.toString()"
				:plantio-marker="{ ...plantioMarker, variavel: findVariavelByCode(plantioMarker.codigo) }"
			/>
		</div>
		<!-- <span v-for="(dataIndividual, index) in cardInfoWithInfoGeo" :key="index"> -->
		<PolygonShape
			v-for="(coordinateAndType, index) in getGeoJsonPtio.features"
			:key="coordinateAndType.properties['Codigo Plantio'] + index"
			:options="{
				fillColor: findColorByCode(coordinateAndType.properties['Codigo Plantio']),
				strokeColor: findColorByCode(coordinateAndType.properties['Codigo Plantio']),
				strokeOpacity: 1,
				fillOpacity: 0.6,
				strokeWeight: 2,
				zIndex: 10,
			}"
			:coordinates="coordinateAndType.geometry.coordinates"
			:type="coordinateAndType.geometry.type"
			:properties="coordinateAndType.properties"
			:clickable="true"
		/>
		<!-- <GmapPolygon
        v-for="(path, index) in dataIndividual.infoGeo.paths"
        :key="index"
        :options="{
          options: {
            visible: dataIndividual.isActived,
            strokeColor: 'white',
            strokeWidth: 1,
            fillColor: '#FFFFFF55',
          },
        }"
        :path="path"
      /> -->
		<!-- </span> -->
	</GmapMap>
</template>

<script>
// import GmapCustomMarker from "vue2-gmap-custom-marker";
import { gmapApi } from 'vue2-google-maps'
import { mapGetters, mapMutations, mapState } from 'vuex'
import PolygonShape from '../../../../components/Map/PolygonShape.vue'
import Switcher from '../../../../components/Switcher/Switcher.vue'
import PlantioMarker from './PlantioMarker/PlantioMarker'

export default {
	components: {
		/*GmapCustomMarker,*/
		PlantioMarker,
		PolygonShape,
		Switcher,
	},
	computed: {
		...mapState('moduleDashboardCardInfo', ['showMarkers']),
		...mapGetters('moduleDashboardCardInfo', ['plantioMarkers', 'coresPlantios', 'bounds']),
		google: gmapApi,
		/**
		 * Retorna os dados que tenham dados de geo
		 */
		cardInfoWithInfoGeo() {
			return this.$store.getters['moduleDashboardCardInfo/cardInfoWithInfoGeo']
		},

		/**
		 * Retorna o geojson de plantio
		 */
		getGeoJsonPtio() {
			return this.$store.state.moduleDashboardCardInfo.plantiosFazenda
		},
	},
	props: {
		/**
		 * Variavel para controlar se esta em dashboard geral ou nao
		 */
		isDashboardGeral: Boolean,
		/**
		 * Seta o id da fazenda do componente pai
		 */
		setFazendaId: Function,
	},
	methods: {
		...mapMutations('moduleDashboardCardInfo', ['setShowMarkers']),
		/**
		 * Retorna a cor do plantio pelo codigo
		 */
		findColorByCode(codigoPlantio) {
			const color = this.coresPlantios.find((cor) => cor.codigo === codigoPlantio)

			return color ? color.cor : '#FFFFFF55'
		},

		findVariavelByCode(codigoPlantio) {
			const cor = this.coresPlantios.find((cor) => cor.codigo === codigoPlantio)

			return cor || {}
		},
		/**
		 * Após clicar em um marker de fazenda seta o id para atualizar o dashboard para a fazenda especificada
		 */
		clickMarker(dataIndividual) {
			if (this.isDashboardGeral && dataIndividual.existeProcessamento) {
				this.setFazendaId(dataIndividual.id)
			} else if (!this.isDashboardGeral && !dataIndividual.isActived) {
				dataIndividual.isActived = true
				this.$store.dispatch(
					'moduleDashboardCardInfo/apiMarkersPlantio',
					dataIndividual.inventarioEstratoFlorestalId,
				)
			} else if (!this.isDashboardGeral && dataIndividual.isActived) {
				dataIndividual.isActived = false
				this.$store.commit(
					'moduleDashboardCardInfo/removeMarkersPlantioByIdEstratoInventarioFlorestal',
					dataIndividual.inventarioEstratoFlorestalId,
				)
			} else {
				dataIndividual.isActived = !dataIndividual.isActived
			}
		},
	},
	watch: {
		/**
		 * Setar o zoom atual inicial, assim que tiver um valor de bound de todos os poligonos
		 */
		bounds: {
			deep: true,
			handler(value) {
				if (Object.keys(value).length > 0 && this.$refs.ref__googlemaps) {
					this.$refs.ref__googlemaps.$mapPromise.then((map) => {
						map.fitBounds(value, 5)
					})
				}
			},
		},
	},
}
</script>

<style scoped>
.container__googlemaps__position {
	width: 100%;
	height: 100%;
	position: relative;
}

.container__marker {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9rem;
	color: white;
	background-color: rgb(var(--color-default));
	padding: 0.5rem 1rem;
	border-radius: 5px;
	font-weight: 500;
	cursor: pointer;
}

.container__marker::before {
	position: absolute;
	content: '';
	width: 0;
	height: 0;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-top: 10px solid rgb(var(--color-default));
	top: 35px;
}

.container__marker.marker--actived {
	color: rgb(var(--color-default));
	background-color: white;
}

.container__marker.marker--actived::before {
	border-top: 10px solid white;
}

.container__marker p {
	margin: 0;
	margin-left: 1rem;
}
</style>
